// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#one-form{margin:10px 0}.one-form-button{text-align:right}", ""]);
// Exports
module.exports = exports;
